import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import { FaChevronCircleUp } from 'react-icons/fa';
import { useStyles } from './styles';

interface IBottomBarProps {
  isCreatingOrder: boolean;
  buttons: string[];
  onClickOpen: any;
  onClickTab?: any;
}

const ToggleBottomBar: React.FC<IBottomBarProps> = ({
  isCreatingOrder,
  buttons,
  onClickOpen,
  onClickTab,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.toggleBottomBar}>
      <button
        id="open-menu"
        className={classes.toggleButton}
        type="button"
        disabled={isCreatingOrder}
        onClick={onClickOpen}
      >
        <FaChevronCircleUp
          size={24}
          color={isCreatingOrder ? 'rgba(112, 48, 160, 0.3)' : '#7030A0'}
        />
      </button>
      {buttons.map((btn, index) => {
        if (index < buttons.length - 1) {
          return (
            <div key={index} className={classes.toggleOrderButtonContainer}>
              <button
                id={`toggle-${btn}`}
                className={classes.toggleOrderButton}
                type="button"
                disabled={isCreatingOrder}
                onClick={() => onClickTab(index)}
              >
                <Typography className={classes.buttonText} variant="subtitle2">
                  {btn}
                </Typography>
              </button>
              <Divider
                flexItem
                orientation="vertical"
                variant="fullWidth"
                style={{ width: 1 }}
              />
            </div>
          );
        }
        return (
          <button
            key={index}
            id={`toggle-${btn}`}
            className={classes.toggleOrderButton}
            type="button"
            disabled={isCreatingOrder}
            onClick={() => onClickTab(index)}
          >
            <Typography className={classes.buttonText} variant="subtitle2">
              {btn}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};

export default ToggleBottomBar;
